module.exports = __webpack_public_path__ + "img/icon-sb-checklist-illustration.3219aea.svg";